module.exports = __webpack_public_path__ + "img/icon-cog.352c77b6.svg";